export type TextSplit = { line1: string; line2: string };

/**
 * Snap a first-line break to a word boundary.
 *
 * The native text layout engine breaks a word mid-character when the first line is narrower than the
 * first word (e.g. a long bet name leaves little inline room, so "Round betting" lays out as "Roun" /
 * "d betting"). Given the full `text` and the character length of the laid-out first line, this
 * retreats the break to the previous space so words are never cut. If no whole word fits on the first
 * line, `line1` is empty and the whole string flows onto `line2`.
 */
export const splitTextAtWordBoundary = (text: string, firstLineLength: number): TextSplit => {
    const brokeMidWord = text[firstLineLength] !== ' ' && text[firstLineLength - 1] !== ' ';
    const breakIndex = brokeMidWord ? text.lastIndexOf(' ', firstLineLength - 1) : firstLineLength;
    // lastIndexOf returns -1 when no earlier space fits; clamp to 0 so the whole string flows onto line2.
    const cut = Math.max(breakIndex, 0);

    return {
        line1: text.slice(0, cut).trim(),
        line2: text.slice(cut).trim(),
    };
};
